import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f557fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs14" }, "入力期限: {周期設定により自動決定}", -1))
const _hoisted_3 = { class: "sub-heading" }
const _hoisted_4 = { class: "items-block" }

import { onMounted, ref, watch } from'vue';
  import { AlertForm } from '@/types/alert_form';
  import type { ElForm } from 'element-plus'

  interface Props {
    alert_form: AlertForm;
    preview: boolean;
  }
  type FormInstance = InstanceType<typeof ElForm>
  
export default /*#__PURE__*/_defineComponent({
  props: {
    alert_form: { type: null, required: true },
    preview: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
    alert_form: AlertForm;
    preview: boolean;
  }
  

  const form_ref = ref<FormInstance>();

  const rules = ref<any>({});
  const form_values = ref<any>({});

  const buildRulesAndValues = (form_el: FormInstance | undefined) => {
    if (!form_el) return;

    rules.value = {};
    form_values.value = {};

    props.alert_form.alert_form_items.forEach((alert_form_item, i) => {
      alert_form_item.alert_form_item_fields.forEach((alert_form_item_field, j) => {
        const key = i + '_' + j;

        rules.value[key] = [
          {
            required: alert_form_item_field.required,
            message: alert_form_item_field.title + 'の入力は必須です',
            trigger: 'change'
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              if (value === '') {
                callback();
                return;
              }
              if (!/^-?[0-9.]+$/.test(value)) {
                callback(new Error('数値を入力してください'))
                return;
              }

              callback();
            },
            trigger: 'change'
          }
        ];
      });
    });
  };

  const clearValidate = (form_el: FormInstance | undefined) => {
    if (!form_el) return;
    form_el.clearValidate();
  };

  onMounted(() => {
    buildRulesAndValues(form_ref.value);
  });
  watch(() => props.alert_form, () => {
    buildRulesAndValues(form_ref.value);
  }, { deep: true })
  watch(() => props.preview, () => {
    clearValidate(form_ref.value);
  })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: (_value, _refs) => {
      _refs['form_ref'] = _value
      form_ref.value = _value
    },
    model: form_values.value,
    rules: rules.value,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.alert_form.title), 1),
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.alert_form.alert_form_items, (alert_form_item, i) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          shadow: "never",
          key: i
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(alert_form_item.title), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alert_form_item.alert_form_item_fields, (alert_form_item_field, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i+'_'+j,
                  class: "item"
                }, [
                  _createVNode(_component_el_form_item, {
                    label: alert_form_item_field.title,
                    prop: i+'_'+j
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form_values.value[i+'_'+j],
                        "onUpdate:modelValue": ($event: any) => ((form_values.value[i+'_'+j]) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label", "prop"])
                ]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})